import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { postGroupDeal, publishGroupDeal } from '../../../store/actions/deals';
import DealFormModal from '../DealFormModal';

const CreateDealModal = ({ isOpen, toggle }) => {
	const dispatch = useDispatch();
	const currentUser = useSelector((state) => state.currentUser);
	const businessId = currentUser?.user?.id;

	const handleSubmit = (payload) => dispatch(postGroupDeal(businessId, payload));
	const handlePublishAfterCreate = (dealId) =>
		dispatch(publishGroupDeal(businessId, dealId));

	return (
		<DealFormModal
			isOpen={isOpen}
			toggle={toggle}
			mode='create'
			onSubmit={handleSubmit}
			onPublishAfterCreate={handlePublishAfterCreate}
		/>
	);
};

export default CreateDealModal;
